import resetForm from './resetForm';
import showModal from './showModal';

export default () => (dispatch) => {
    dispatch(resetForm());
    dispatch(showModal(false));
};
